(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["manual-product-cards"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const cards = document.querySelectorAll('.manual-product-card--has-hover');
    if (!cards.length) return;

    for (const card of cards) {
      card.addEventListener(
        'pointerenter',
        () => {
          const hoverImg = card.querySelector('.manual-product-card__image--hover');
          if (hoverImg instanceof HTMLImageElement && hoverImg.loading === 'lazy') {
            hoverImg.loading = 'eager';
          }
        },
        { once: true }
      );
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
